import { useState, useEffect, useCallback } from 'react';
import { useApi } from '../hooks/useApi';

// Integración de pagos del dueño (por ahora solo Mercado Pago). Conectar/Desconectar
// por OAuth; la cuenta vinculada se muestra sin exponer el token (va cifrado en el back).
export default function IntegracionPagos() {
  const api = useApi();
  const [st, setSt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null); // { ok, text } tras volver del OAuth

  const load = useCallback(() => {
    setLoading(true);
    api.get('/api/mp/status').then(setSt).catch(() => setSt(null)).finally(() => setLoading(false));
  }, []); // eslint-disable-line
  useEffect(() => { load(); }, [load]);

  // Al volver del callback de MP llega ?mp=connected|error; lo mostramos y limpiamos.
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const mp = p.get('mp');
    if (mp === 'connected') setMsg({ ok: true, text: 'Mercado Pago conectado correctamente.' });
    else if (mp === 'error') setMsg({ ok: false, text: 'No se pudo conectar Mercado Pago. Intentá de nuevo.' });
    if (mp) { p.delete('mp'); window.history.replaceState({}, '', window.location.pathname + (p.toString() ? '?' + p : '')); }
  }, []);

  async function connect() {
    setBusy(true);
    try {
      const r = await api.get(`/api/mp/connect?return_url=${encodeURIComponent(window.location.origin)}`);
      if (r.url) window.location.href = r.url; else throw new Error('No se pudo iniciar la conexión');
    } catch (e) { alert(e.message || 'No se pudo iniciar la conexión'); setBusy(false); }
  }
  async function disconnect() {
    if (!window.confirm('¿Desconectar tu Mercado Pago? Vas a dejar de cobrar online hasta que reconectes.')) return;
    setBusy(true);
    try { await api.post('/api/mp/disconnect', {}); setMsg(null); load(); }
    catch (e) { alert(e.message); } finally { setBusy(false); }
  }

  const acc = st?.account;
  const ident = acc?.identification;

  return (
    <div className="lb-fade" style={{ maxWidth: 620 }}>
      <div className="lb-eyebrow" style={{ marginBottom: 6 }}>Integración de pagos</div>
      <p style={{ color: 'var(--ink-700)', fontSize: 14, marginTop: 0, marginBottom: 20 }}>
        Conectá tu cuenta de Mercado Pago para cobrar las entradas online. El dinero de las ventas va directo a tu cuenta.
      </p>

      {msg && (
        <div style={{ border: `1px solid ${msg.ok ? 'rgba(46,204,113,0.5)' : 'rgba(200,16,46,0.5)'}`, background: msg.ok ? 'rgba(46,204,113,0.08)' : 'rgba(200,16,46,0.08)', borderRadius: 6, padding: '12px 16px', marginBottom: 18, fontSize: 13, color: msg.ok ? '#2ecc71' : 'var(--red-400)' }}>
          {msg.text}
        </div>
      )}

      {loading && <div style={{ color: 'var(--ink-600)', fontSize: 13 }}>Cargando…</div>}

      {!loading && (
        <div className="lb-card" style={{ padding: '24px 26px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <div style={{ width: 40, height: 40, borderRadius: 8, background: '#009ee3', display: 'grid', placeItems: 'center', color: '#fff', fontWeight: 800, fontSize: 18 }}>MP</div>
            <div>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>Mercado Pago</div>
              <div style={{ fontSize: 12, color: st?.connected ? '#2ecc71' : (st?.needs_reconnect ? 'var(--red-400)' : 'var(--ink-600)') }}>
                {st?.connected ? 'Conectado' : st?.needs_reconnect ? 'Reconexión requerida' : 'No conectado'}
              </div>
            </div>
          </div>

          {st?.needs_reconnect && (
            <div style={{ border: '1px solid rgba(200,16,46,0.5)', background: 'rgba(200,16,46,0.08)', borderRadius: 6, padding: '12px 16px', marginBottom: 16, fontSize: 13, color: 'var(--ink-700)' }}>
              <b style={{ color: 'var(--red-400)' }}>Tu conexión con Mercado Pago expiró.</b> Reconectá para volver a cobrar online. Mientras tanto, tus eventos no pueden vender online.
            </div>
          )}

          {st?.connected && acc && (
            <div style={{ fontSize: 13, color: 'var(--ink-700)', display: 'grid', gap: 6, marginBottom: 18 }}>
              <div><span style={{ color: 'var(--ink-600)' }}>Cuenta: </span><b style={{ color: '#fff' }}>{acc.nickname || acc.email || acc.user_id}</b></div>
              {acc.email && <div><span style={{ color: 'var(--ink-600)' }}>Email: </span>{acc.email}</div>}
              {ident?.number && <div><span style={{ color: 'var(--ink-600)' }}>{ident.type || 'CUIT'}: </span>{ident.number}</div>}
              {st.connected_by?.name && <div><span style={{ color: 'var(--ink-600)' }}>Vinculada por: </span>{st.connected_by.name}</div>}
            </div>
          )}

          {st?.connected
            ? <button className="lb-btn lb-btn--ghost lb-btn--sm" disabled={busy} onClick={disconnect}>Desconectar</button>
            : <button className="lb-btn lb-btn--primary" style={{ background: '#009ee3', borderColor: '#009ee3' }} disabled={busy} onClick={connect}>
                {busy ? 'Redirigiendo…' : (st?.needs_reconnect ? 'Reconectar con Mercado Pago' : 'Conectar con Mercado Pago')}
              </button>}
        </div>
      )}
    </div>
  );
}
